import { observable } from 'mobx';

export interface ICourier {
    id: string;
    expires: string;
    available: boolean;
}

export class Courier implements ICourier {
    @observable public id: string;
    @observable public expires: string;
    @observable public available: boolean;

    /* eslint-disable @typescript-eslint/no-explicit-any */
    public static fromJson(data: any): ICourier {
        const courier = new Courier();

        courier.id = data.content.id;
        courier.expires = data.content.expires;
        courier.available = data.success;

        return courier;
    }
}
